import poiseWithModules from '../../components/CourseWithModules';
import poiseCourseRegistration from '../../components/CourseRegistration';
import poiseCourseWrapper from '../../components/CourseWrapper';

const navigations = [poiseCourseWrapper, poiseWithModules, poiseCourseRegistration];

export default navigations;
